import APIClient from '@/shared/http/clients/api'

const resourceName = 'AprTemplateFerramentas'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAPRTemplateFerramentasGrid = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAPRTemplateFerramentasGrid?limit=${limit}&index=${index}`, data, config)

const APRTemplateFerramentasRepository = {
  GetAPRTemplateFerramentasGrid
}

export default APRTemplateFerramentasRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprTools.js